<template>
    <!-- info card start -->
    <div class="card">
        <div class="card-header">
            <h5 class="card-header-text">Documents and Videos</h5>
        </div>
        <div class="card-block">
            <div class="row">
                <div class="col-md-6" v-for="(document, index) in $parent.applicant.documents" v-if="document.document_type == 'cv'">
                    <div class="card b-l-success business-info services m-b-20">
                        <div class="card-header">
                            <div class="service-header" text-align="center">
                                <h5 class="card-header-text">Document</h5>
                            </div>
                        </div>
                        <div class="card-block">
                            <div class="row">
                                <div class="col-md-6" v-for="(document, index) in $parent.applicant.documents" v-if="document.document_type == 'cv'">
                                    <div class="col-sm-12">
                                        <a class="btn btn-primary btn-sm"  v-bind:href="getFile(document.link)"
                                            target="_blank" v-if="document.document_type == 'cv'" download> Download
                                            Resume
                                        </a>
                                    </div>
                                </div>
                                <div class="col-md-6" v-for="(document, index) in $parent.applicant.documents" v-if="document.document_type == 'other'">
                                    <div class="col-sm-12">
                                        <a class="btn btn-primary btn-sm"  v-bind:href="getFile(document.link)"
                                            target="_blank" v-if="document.document_type == 'other'" download> Download
                                            FSLC
                                        </a>
                                    </div>
                                </div>

                            </div>

                            <!-- end of col-sm-8 -->
                        </div>
                        <div class="card-block">
                            <div class="row">
                                <div class="col-md-6" v-for="(document, index) in $parent.applicant.documents" v-if="document.document_type == 'Undergraduate'">
                                    <div class="col-sm-12">
                                        <a class="btn btn-primary btn-sm"  v-bind:href="getFile(document.link)"
                                            target="_blank" v-if="document.document_type == 'Undergraduate'" download>
                                            Download
                                            Undergraduate
                                        </a>
                                    </div>
                                </div>
                                <div class="col-md-6" v-for="(document, index) in $parent.applicant.documents" v-if="document.document_type == 'passport'">
                                    <div class="col-sm-12">
                                        <a class="btn btn-primary btn-sm"  v-bind:href="getFile(document.link)"
                                            target="_blank" v-if="document.document_type == 'passport'" download>
                                            Download Passport
                                        </a>
                                    </div>
                                </div>

                            </div>

                            <!-- end of col-sm-8 -->
                        </div>
                        <div class="card-block">
                            <div class="row">
                                <div class="col-md-6" v-for="(document, index) in $parent.applicant.documents" v-if="document.document_type == 'waec'">
                                    <div class="col-sm-12">
                                        <a class="btn btn-primary btn-sm"  v-bind:href="getFile(document.link)"
                                            target="_blank" v-if="document.document_type == 'waec'" download> Download
                                            WAEC Certificte
                                        </a>
                                    </div>
                                </div>
                                <div class="col-md-6" v-for="(document, index) in $parent.applicant.documents" v-if="document.document_type == 'nysc'">
                                    <div class="col-sm-12">
                                        <a class="btn btn-primary btn-sm"  v-bind:href="getFile(document.link)"
                                            target="_blank" v-if="document.document_type == 'nysc'" download> Download
                                            NYSC
                                        </a>
                                    </div>
                                </div>

                            </div>

                            <!-- end of col-sm-8 -->
                        </div>
                        <!-- end of row -->
                    </div>
                    <!-- end of card-block -->
                </div>
                <!--</div>-->
            </div>
        </div>
        <div class="card-block">
            <div class="row">
                <div class="col-md-6" v-for="(document, index) in $parent.applicant.documents" v-if="document.document_type == 'stage2video'">
                    <div class="card b-l-warning business-info services m-b-20">
                        <div class="card-header">
                            <div class="service-header">
                                <h5 class="card-header-text">Video</h5>
                            </div>
                        </div>
                        <div class="card-block">
                            <div class="row">
                                <div class="col-sm-12">
                                    <video width="100%" height="300" controls>
                                        <source v-bind:src="'https://sundryfoods.website/public/'+document.link">
                                    </video>
                                </div>
                                <!-- end of col-sm-8 -->
                            </div>
                            <!-- end of row -->
                        </div>
                        <!-- end of card-block -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- info card end -->
</template>

<script type="text/javascript">
    export default {
        name: 'DocumentsAndVideos',
        method: {
             getFile(file) {
                return file.includes('https://') ? file : 'https://sundryfoods.website' + file;
            },

        }
    }
</script>